define('shared/initializer/form/newHouseAdapters/mixins/AdyenPayable',[
    '$',
    'shared/util/state',
    'shared/remote/ajax',
    'shared/remote/payment/adyen/initSession',
    'shared/remote/payment/adyen/checkOrderStatus',
    'shared/util/adyen/storage',
    'shared/lib/URI',
    'kernel/ui/Blocker',
    'shared/page/env',
    'shared/util/state/adapters/order',
    'shared/initializer/form/constants',
    'Promise'
],
    function (
        $,
        state,
        ajax,
        initPaymentSession,
        checkOrderStatus,
        storage,
        URI,
        Blocker,
        env,
        orderAdapter,
        constants,
        Promise
    ) {
        'use strict';

        //define constants
        var idCount = 0;
        var PAYMENT_AUTHORISED = 'authorised';
        var ORDERED = 'Ordered';
        var PENDING = 'Pending';
        var ORDER_QUERY_COUNT = 20;
        var ORDER_QUERY_INTERVAL_MS = 3000;
        var ADYEN_SCRIPT_LIVE = 'https://checkoutshopper-live.adyen.com/checkoutshopper/assets/js/sdk/checkoutSDK.1.9.2.min.js';
        var ADYEN_SCRIPT_TEST = 'https://checkoutshopper-test.adyen.com/checkoutshopper/assets/js/sdk/checkoutSDK.1.9.2.min.js';
        var ADYEN_MODULE_NAME = 'adyen-payment-form::';
        var IS_LIVE;
        var adyenScriptLoaded = false;
        var REJECTED = 'rejected';

        var uri = new URI(location.href);
        var searchParameters = uri.query(true);

        function addScript(src) {
            if (adyenScriptLoaded) {
                return adyenScriptLoaded;
            }
            adyenScriptLoaded = new Promise(function(rs){
                $.getScript(src, rs);
            });
            return adyenScriptLoaded;
        }

        function rejectPayment() {
            var err = new Error('Payment rejected');
            err.fatal = false;
            err.type = REJECTED;
            return Promise.reject(err);
        }

        function rejectWithOrderCreationFailed() {
            var err = new Error('Order creation failure');
            err.type = 'orderCreationFailed';
            err.redirect = true;
            return Promise.reject(err);
        }

        function initPaymentFlow(form) {
            var offers;
            return env()
            .then(function (environment) {
                if (environment === 'live') {
                    IS_LIVE = true;
                    return addScript(ADYEN_SCRIPT_LIVE);
                } else {
                    IS_LIVE = false;
                    return addScript(ADYEN_SCRIPT_TEST);
                }
            })
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                return state.retrieve(constants.State.OrderOfferId);
            })
            .then(function(value){
                offers = value;
                if (!offers || offers.length <= 0) {
                    return Promise.reject('No offer id specified');
                }
            })
            .then (function () {
                return initPaymentSession(offers);
            })
            .then(function (res) {
                console.log(ADYEN_MODULE_NAME, 'Payment form initialized');
                var chckt = window.chckt;
                try {
                    var paymentSession = JSON.parse(res.PaymentFlow.ExtraInfo.http_redirect_parameters);
                } catch (err) {
                    console.log(ADYEN_MODULE_NAME, 'Failed to obtain paymentSession', err);
                }
                var sdkConfigObj = {
                    context: IS_LIVE ? 'live' : 'test'
                };
                storage.storeOrderId(res.Order.Order_id);
                var $adyen = form.$form
                    .find('.payment-form');
                var tmpId = 'adyen-wrapper-' + idCount++;
                $adyen.attr('id', tmpId);
                // Initiate the Checkout form.
                chckt.checkout(paymentSession, '#' + tmpId, sdkConfigObj);
                chckt.hooks.beforeComplete = function (node, paymentData) {
                    form._resultCode = paymentData.resultCode;
                    form.emit('payment.start');
                    // Indicates that you want to replace the default handling.
                    return false;
                };
            }).then(null, function (err) {
                return Promise.reject(err);
            });
        }

        function Ctor() {}

        Ctor.prototype.doError = function() {
            return initPaymentFlow(this);
        };

        Ctor.prototype.doPageLoad = function() {
            if (searchParameters.resultCode) {
                this._resultCode = searchParameters.resultCode;
                this.emit('payment.start');
                return;
            }
            
            return initPaymentFlow(this);
        };

        Ctor.prototype.doSubmit = function() {
            var form = this;
            var orderId = storage.retrieveOrderId();
            var orderInfo;
            var orderStatus;
            var count = 0;

            function makeSureOrderIsOrdered() {
                return checkOrderStatus(orderId)
                    .then(function(result){
                        orderInfo = result;
                        orderStatus = orderInfo.Status;
                    })
                    .then(function(){
                        if (orderStatus === ORDERED) {
                            return;
                        }
                        
                        if (
                            orderStatus === PENDING && 
                            count < ORDER_QUERY_COUNT
                        ) {
                            count++;
                            return new Promise(function(rs){
                                setTimeout(rs, ORDER_QUERY_INTERVAL_MS);
                            })
                                .then(function(){
                                    return makeSureOrderIsOrdered();
                                });
                        }
                        
                        return rejectWithOrderCreationFailed();
                    }, function(){
                        return rejectWithOrderCreationFailed();
                    });
            }

            return Promise.resolve()
                .then(function(){
                    if (form._resultCode.toLowerCase() === PAYMENT_AUTHORISED) {
                        return;
                    } 
                    
                    return rejectPayment();
                })
                .then(function(){
                    return makeSureOrderIsOrdered();
                })
                .then(function () {
                    storage.deleteOrderId();
                    return orderInfo;
                }, function(err) {
                    storage.deleteOrderId();
                    return Promise.reject(err);
                });
        };
    
        return Ctor;
        
    });
